import React from "react";
import axios from "services/axiosB2C";
import Axios from "axios";
import { RequestToken } from "../../../../services/b2c";

import { Button, Card, message, Spin, Tooltip } from "antd";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";

import { errorMessage } from "../../../Utils";
let cancelToken;

class CustomerCarList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerCarList: [],
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "create", direction: "desc" },
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchCustomerCar(this.state.page, this.state.limit);
  }

  async fetchCustomerCar(page, limit) {
    this.setState({ isLoading: true });

    let { sort, search } = this.state;
    let order = this.orderBy(sort);
    let query = `${order}&page=${page}&limit=${limit}&search=${search || ""}`;

    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    let token = await RequestToken();
    await axios
      .get(`/customercars?${query}`, {
        cancelToken: cancelToken.token,
        headers: {
          Authorization: token,
        },
      })
      .then(result => {
        this.setState({
          customerCarList: result.data.customerCars,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Hari/Tgl Dibuat") key = "create";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchCustomerCar(page, limit);
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Email",
        options: {
          sort: false,
        },
      },
      {
        name: "Brand",
        options: {
          sort: false,
        },
      },
      {
        name: "Model",
        options: {
          sort: false,
        },
      },
      {
        name: "Tipe",
        options: {
          sort: false,
        },
      },
      {
        name: "Year",
        options: {
          sort: false,
        },
      },
      {
        name: "Nomor Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Nomor Rangka",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Dibuat",
        options: {
          sort: false,
        },
      },
    ];

    // Data Customer Car List //
    const customerCarList = this.state.customerCarList.map((item, idx) => {
      return [
        <div>
          <Link to={`/home/customer-car/${item.id}`}>
            <Tooltip placement="bottom" title="Detail Customer Car">
              <Button icon="bars" style={{ marginRight: 10 }} />
            </Tooltip>
          </Link>
        </div>,
        item.user ? item.user.email : null,
        item.brand,
        item.type,
        item.spec,
        item.year,
        item.license_plate,
        item.engine_number,
        momentTZ(item.created_at)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: parseInt(this.state.limit),
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Customer Car List"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Customer Car"
              data={customerCarList}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default CustomerCarList;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/CustomerCar/CustomerCar.js